import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-invite-friends-modal',
  templateUrl: './invite-friends-modal.component.html',
  styleUrls: ['./invite-friends-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InviteFriendsModalComponent {

}
